import React from "react";
import styles from "../../styles/dashboard.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faPlus} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function PageTitle({openModal, children, title, back, createName}) {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const goBack = () => {
        navigate(back);
    }

    return (
        <div className='d-flex flex-row justify-content-between mt-3 flex-wrap' style={{fontFamily: "Poppins", userSelect: "none"}}>
            <div className={'d-flex align-items-center'}>
                {back &&
                <div role={'button'} onClick={() => goBack()}>
                    <FontAwesomeIcon icon={faArrowLeft} size={'lg'} className={'pe-3'}/>
                </div>
                }
                <div className={styles.title}>{title}</div>
            </div>

            {openModal &&
                <div className='d-flex flex-row align-items-center flex-wrap' style={{rowGap: '8px'}}>
                    {children}
                    <div className={`d-flex flex-row rounded-3 ${styles.primary_button}`}
                         style={{
                             whiteSpace: "nowrap",
                         }}
                         onClick={() => openModal(true)}>
                        <FontAwesomeIcon icon={faPlus} color="#FFF"/>
                        <div>{t('common.new', {name: createName})}</div>
                    </div>
                </div>
            }
        </div>
    );
}